<template>
  <Card class="mt-2">
    <template #title> Settings </template>
    <template #content>
      <div class="grid">
        <div class="col-12">Settings</div>
        <div class="field col-12 md:col-6 lg:col-4">
          <div>{{ required ? 'Required' : 'Not Required' }}</div>
          <InputSwitch v-model="required" />
        </div>
      </div>
    </template>
  </Card>
  <Divider />
  <Card>
    <template #title> Component </template>
    <template #content>
      <form class="mt-5" @submit.prevent="submitForm">
        <DatePickerRange v-model="date" label="Date Picker (Range)" required></DatePickerRange>
        <Button type="submit" label="Submit" @click.prevent="v.$validate"></Button>
      </form>
    </template>
  </Card>
  <Divider></Divider>
  <Card>
    <template #title> Output </template>
    <template #content>
      <p>{{ date }}</p>
    </template>
  </Card>
</template>
<script setup>
import { ref } from 'vue'
import DatePickerRange from '@/components/input/DatePickerRange.vue'
import useValidate from '@vuelidate/core'
const required = ref(true)
const date = ref(new Date())
const v = useValidate()

const submitForm = async () => {
  const result = await v.value.$validate()
  if (result) {
    alert('success')
  } else {
    alert('error')
  }
}
</script>
